import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "top",
  class: "min-h-screen bg-gradient-to-br from-gray-50 to-blue-50"
}
const _hoisted_2 = { class: "fixed top-0 w-full bg-white/80 backdrop-blur-md shadow-sm z-50" }
const _hoisted_3 = { class: "max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 py-4" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "flex items-center space-x-8" }
const _hoisted_6 = { class: "hidden md:flex space-x-8" }
const _hoisted_7 = {
  href: "#about",
  class: "text-gray-600 hover:text-blue-600 transition-colors"
}
const _hoisted_8 = {
  href: "#skills",
  class: "text-gray-600 hover:text-blue-600 transition-colors"
}
const _hoisted_9 = {
  href: "#certifications",
  class: "text-gray-600 hover:text-blue-600 transition-colors"
}
const _hoisted_10 = {
  href: "#experience",
  class: "text-gray-600 hover:text-blue-600 transition-colors"
}
const _hoisted_11 = {
  href: "#education",
  class: "text-gray-600 hover:text-blue-600 transition-colors"
}
const _hoisted_12 = {
  href: "#projects",
  class: "text-gray-600 hover:text-blue-600 transition-colors"
}
const _hoisted_13 = {
  href: "#articles",
  class: "text-gray-600 hover:text-blue-600 transition-colors"
}
const _hoisted_14 = { class: "pt-24 pb-16 px-6 sm:px-8 lg:px-12" }
const _hoisted_15 = { class: "max-w-6xl mx-auto text-center" }
const _hoisted_16 = { class: "text-5xl font-bold text-gray-800 mb-4" }
const _hoisted_17 = { class: "bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent" }
const _hoisted_18 = { class: "text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed" }
const _hoisted_19 = { class: "mt-8 flex justify-center space-x-4" }
const _hoisted_20 = {
  href: "https://github.com/sea-turt1e",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "bg-blue-600 text-white px-8 py-3 rounded-full hover:bg-blue-700 transition-colors shadow-lg inline-block text-center no-underline"
}
const _hoisted_21 = {
  href: "mailto:h.yamada.bg@gmail.com?subject=お問い合わせ",
  class: "border border-blue-600 text-blue-600 px-8 py-3 rounded-full hover:bg-blue-600 hover:text-white transition-colors inline-block text-center no-underline"
}
const _hoisted_22 = { class: "max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 space-y-20" }
const _hoisted_23 = { id: "about" }
const _hoisted_24 = { id: "skills" }
const _hoisted_25 = { id: "certifications" }
const _hoisted_26 = { id: "experience" }
const _hoisted_27 = { id: "education" }
const _hoisted_28 = { id: "projects" }
const _hoisted_29 = { id: "articles" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LanguageSwitcher = _resolveComponent("LanguageSwitcher")!
  const _component_ProfileSection = _resolveComponent("ProfileSection")!
  const _component_SkillSection = _resolveComponent("SkillSection")!
  const _component_CertificationSection = _resolveComponent("CertificationSection")!
  const _component_ExperienceSection = _resolveComponent("ExperienceSection")!
  const _component_EducationSection = _resolveComponent("EducationSection")!
  const _component_ProjectSection = _resolveComponent("ProjectSection")!
  const _component_ZennArticleSection = _resolveComponent("ZennArticleSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent" }, [
            _createElementVNode("a", {
              href: "#top",
              class: "cursor-pointer no-underline hover:underline"
            }, " sea-turt1e's Portfolio ")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('navigation.profile')), 1),
              _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('navigation.skills')), 1),
              _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t('navigation.certifications')), 1),
              _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t('navigation.experience')), 1),
              _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$t('navigation.education')), 1),
              _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('navigation.projects')), 1),
              _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$t('navigation.articles')), 1)
            ]),
            _createVNode(_component_LanguageSwitcher)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("h2", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.$t('profile.greeting')), 1),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('profile.name')), 1)
        ]),
        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('profile.description')), 1),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.$t('profile.githubLink')), 1),
          _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.$t('profile.contactLink')), 1)
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_ProfileSection)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_SkillSection)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_CertificationSection)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_ExperienceSection)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_EducationSection)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_ProjectSection)
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_ZennArticleSection)
      ])
    ]),
    _cache[2] || (_cache[2] = _createStaticVNode("<footer class=\"bg-gray-800 text-white py-12 mt-20\"><div class=\"max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 text-center\"><p class=\"text-gray-400\">© 2025 sea-turt1e. All rights reserved.</p><div class=\"mt-4 flex justify-center space-x-6\"><a href=\"https://github.com/sea-turt1e\" class=\"text-gray-400 hover:text-white transition-colors\" target=\"_blank\" rel=\"noopener noreferrer\">GitHub</a><a href=\"https://zenn.dev/sea_turt1e\" class=\"text-gray-400 hover:text-white transition-colors\" target=\"_blank\" rel=\"noopener noreferrer\">Zenn</a></div></div></footer>", 1))
  ]))
}